<div class="submit-button-wrapper" [class.validating]="validating()" [attr.aria-busy]="validating()">
  <ng-content select="[type=submit]"></ng-content>
</div>
<ng-content></ng-content>
